export function formatPrice(price, fixed = null) {
  if (!price) return price;

  const num = Number(price);
  if (isNaN(num)) return price;

  let stringified;

  if (fixed !== null) {
    stringified = num.toFixed(fixed); // limit decimal
  } else {
    stringified = num.toString(); // full value as is
  }

  const [integer, decimal] = stringified.split('.');
  const formattedInteger = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  return decimal ? `${formattedInteger}.${decimal}` : formattedInteger;
}